import React from "react";
import Layout from "../components/layout";
import HomeImage4 from "../assets/images/phoneScreens/home4.png";
import HomeImage5 from "../assets/images/phoneScreens/home5.png";
import HomeImage1 from "../assets/images/phoneScreens/home1.png";
import HomeImage2 from "../assets/images/phoneScreens/home2.png";
import HomeImage3 from "../assets/images/phoneScreens/home3.png";
import Settting1 from "../assets/images/phoneScreens/Setting1.png";
import Settting2 from "../assets/images/phoneScreens/Setting2.png";
import Settting3 from "../assets/images/phoneScreens/Setting3.png";
import Settting4 from "../assets/images/phoneScreens/Setting4.png";
import Settting5 from "../assets/images/phoneScreens/Setting5.png";
import Calendar1 from "../assets/images/phoneScreens/calendar1.png";
import Calendar2 from "../assets/images/phoneScreens/calendar2.png";
import Expanded1 from "../assets/images/phoneScreens/event_expanded1.png";
import Expanded2 from "../assets/images/phoneScreens/event_expanded2.png";
import MapImage1 from "../assets/images/phoneScreens/map1.png";
import MapImage2 from "../assets/images/phoneScreens/map2.png";

const Features = () => {
  const SectionOrder = (props) => {
    return (
      <div className="px-4 md:px-8 lg:px-16 py-8 md:py-16 mx-auto lg:flex max-w-6xl">
        <div className="pb-8 lg:pr-12">
          <h1 className="font-bold text-xl md:text-2xl leading-tight">
            {props.title}
          </h1>
          <h2 className="text-gray-800 text-lg leading-7 pt-2 md:pt-8 ">
            {props.body}
          </h2>
        </div>
        <div className="mx-auto md:justify-between md:mx-0 w-full flex overflow-x-scroll space-x-4 ">
          {props.images.map((item) => {
            return (
              <img
                className="w-48 h-full object-contain"
                src={item}
                alt="Home 1"
              />
            );
          })}
        </div>
      </div>
    );
  };
  const SectionUnOrder = (props) => {
    return (
      <div className="px-4 md:px-8 lg:px-16 py-8 md:py-16 mx-auto lg:flex max-w-6xl">
        <div className="pb-8 lg:pl-12 order-2">
          <h1 className="font-bold text-xl md:text-2xl leading-tight">
            {props.title}
          </h1>
          <h2 className="text-gray-800 text-lg leading-7 pt-2 md:pt-8 ">
            {props.body}
          </h2>
        </div>
        <div className="mx-auto md:mx-0 w-full flex overflow-x-scroll space-x-4 md:justify-between order-1">
          {props.images.map((item) => {
            return (
              <img
                className="w-48 h-full object-contain"
                src={item}
                alt="Home 1"
              />
            );
          })}
        </div>
      </div>
    );
  };
  return (
    <div>
      <Layout>
        <div className="">
          <h1 className="text-2xl font-bold text-center text-gray-800 uppercase py-8 ">
            Project Features
          </h1>
          <div className=" bg-white ">
            {/* Home Tab */}
            <SectionOrder
              title="Home View"
              body={[
                "On the Calendar View, swipe through all the months and see which days have events.",
                <br />,

                "Navigate to the Calendar View by tapping the second tab on the Bottom Navigation Bar.",
                <br />,

                "Today’s date will have a green circular outline.",
                <br />,
                "You can select a day to view that day’s events. Selected days will have a green-filled circle behind the date, and a list of the day’s events will appear below the calendar that you can scroll through.",
                <br />,
                "Days can have indicators below them. Green indicators mean that day has at least one event. Gold indicators only appear when that day is selected with the green-filled circle.",
                <br />,
                "“Today’s Events” and “Tomorrow’s Events” will show a preview of the events available on their respective days. Tap “See More” to view all the available events for that day.",
                <br />,
                "You can swipe left and right on the calendar to see a few months into the future or past, with a total of five calendar month options. You can also see what semester that month is in!",
                <br />,
              ]}
              images={[
                HomeImage4,
                HomeImage2,
                HomeImage3,
                HomeImage5,
                HomeImage1,
              ]}
            />

            {/* Calendar View */}
            <SectionUnOrder
              title="Calendar View"
              body={[
                "On the Calendar View, swipe through all the months and see which days have events.",
                <br />,
                "Navigate to the Calendar View by tapping the second tab on the Bottom Navigation Bar.",
                <br />,

                "Today’s date will have a green circular outline.",
                <br />,

                "You can select a day to view that day’s events. Selected days will have a green-filled circle behind the date, and a list of the day’s events will appear below the calendar that you can scroll through.",
                <br />,

                "Days can have indicators below them. Green indicators mean that day has at least one event. Gold indicators take priority over green indicators. Gold implies that that day has at least one favorite event. Tap the day to see if it has more events!",
                <br />,

                "You can swipe left and right on the calendar to see a few months into the future or past. You can also see what semester that month is in!",
                <br />,
              ]}
              images={[Calendar1, Calendar2]}
            />

            {/* EventDetail Tab */}
            <SectionOrder
              title="Event Detail View"
              body={[
                "On the Expanded Event Card View, you can see all the details for an event.",
                <br />,

                "Tap on any event card to expand it, and you’ll be directed to the Expanded Event Card View.",
                <br />,

                "Here you can see an event’s details, such as the title, location, date and time, and the description. If the event has an image, that’ll be displayed as well.",
                <br />,
                "You can interact with the event in a few ways.Tapping the heart icon will add the event to your favorites.",
                <br />,
                "Tapping the pin icon will direct you to the event’s pin on the Map View.",
                <br />,
                "Please note that the pin icon will only appear if the event has a physical location on campus.",
                <br />,
              ]}
              images={[Expanded1, Expanded2]}
            />

            {/* Map Tab */}
            <SectionUnOrder
              title="Map View"
              body={[
                "On the Map View, you can see all of today’s on-campus events as pins on a map.",
                <br />,

                "Tap on any event pin to see some more details about the event. Tap again to be taken to the Expanded Event Card View for that event.",
                <br />,

                "Event pins will be placed at their respective locations on the map. If a location has multiple events, they will be grouped together. Tap the group pin to view the contained events.",
                <br />,
                "Tap the AR Action Button to direct yourself to the AR View.",
              ]}
              images={[MapImage1, MapImage2]}
            />
            <div className="flex justify-center container mx-auto lg:px-16 xl:px-0 px-4 flex-col md:px-8 max-w-5xl">
              <h1 className="font-bold text-xl md:text-2xl leading-tight pb-3 md:pb-8">
                AR Demo
              </h1>
              {/* <iframe
                title="Ar demo"
                height="420"
                className="w-full"
                src="https://www.youtube.com/embed/mW7d1O9_d7k"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe> */}
              <iframe
                title="AR demo"
                height="420"
                className="w-full"
                src="https://www.youtube.com/embed/mW7d1O9_d7k"
                frameborder="0"
                allowFullScreen="true"
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
              ></iframe>
            </div>
            {/* Setting Tab */}
            <SectionOrder
              title="Setting View"
              body={[
                "On the Settings View, you can view information about Hornet Vision, send feedback, and change your notifications.",
                <br />,
                "The Settings View has expandable options that will contain descriptions for each Setting.",
                <br />,
                "You can read about what data is stored on your device, what device permissions are required or optional, what the terms & conditions are, and what brought Hornet Vision to life.",
                <br />,
                "You can also send feedback to IRT if you have any questions or concerns.",
                <br />,
              ]}
              images={[Settting1, Settting2, Settting3, Settting4, Settting5]}
            />
            <div className="border border-b-1 border-gray-100 shadow-sm"></div>
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default Features;
